import { render } from "./ModalService.vue?vue&type=template&id=8de0ce6e&scoped=true"
import script from "./ModalService.vue?vue&type=script&lang=js"
export * from "./ModalService.vue?vue&type=script&lang=js"

import "./ModalService.vue?vue&type=style&index=0&id=8de0ce6e&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de0ce6e"]])

export default __exports__